import { render } from "./Noticias.vue?vue&type=template&id=66f4a730&scoped=true"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"

import "./Noticias.vue?vue&type=style&index=0&id=66f4a730&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f4a730"]])

export default __exports__